export enum UserProductStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  DeleteManually = 'DeleteManually',
}
